import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-unattended",
  "use": "icon-nav-unattended-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-nav-unattended\"><path d=\"M4 14a8 8 0 0116 0\" /><path d=\"M12 14v4\" /><circle cx=\"12\" cy=\"9\" r=\"3\" /><path d=\"M8 21h8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/nav-unattended.svg
// module id = Itmw
// module chunks = 24